<template>
  <div class="min-h-screen bg-gradient-to-br from-psychology-calm via-white to-psychology-warm">
    <!-- 顶部导航 -->
    <nav class="sticky top-0 z-50 bg-white/80 backdrop-blur-md border-b border-gray-200">
      <div class="container mx-auto px-4 py-4">
        <div class="flex items-center justify-between">
          <div class="flex items-center gap-3">
            <router-link to="/" class="inline-flex items-center gap-2 px-3 py-2 hover:bg-gray-100 rounded-md transition-colors text-gray-600 hover:text-gray-900">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-4 h-4">
                <path d="M15 21v-8a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v8"></path>
                <path d="M3 10a2 2 0 0 1 .709-1.528l7-5.999a2 2 0 0 1 2.582 0l7 5.999A2 2 0 0 1 21 10v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
              </svg>
              首页
            </router-link>
            <div class="flex items-center gap-2">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-5 h-5 text-psychology-primary">
                <path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z"></path>
              </svg>
              <span class="font-semibold text-psychology-primary">{{ assessmentType === 'self' ? '给自己测' : '为恋人测' }}</span>
            </div>
          </div>
          <button @click="goBack" class="hidden sm:inline-flex items-center gap-2 px-3 py-2 border border-gray-300 bg-white hover:bg-gray-50 rounded-md transition-colors text-gray-600">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-4 h-4">
              <path d="m12 19-7-7 7-7"></path>
              <path d="M19 12H5"></path>
            </svg>
            返回
          </button>
          <button @click="goBack" class="sm:hidden inline-flex items-center justify-center p-2 border border-gray-300 bg-white hover:bg-gray-50 rounded-md transition-colors text-gray-600">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-4 h-4">
              <path d="m12 19-7-7 7-7"></path>
              <path d="M19 12H5"></path>
            </svg>
          </button>
        </div>

        <!-- 进度条 -->
        <div class="mt-4">
          <div class="flex justify-between items-center mb-2">
            <span class="text-sm text-gray-600">整体进度</span>
            <span class="text-sm font-medium">50%</span>
          </div>
          <div class="relative w-full overflow-hidden rounded-full bg-gray-200 h-2">
            <div class="h-full bg-psychology-primary transition-all" style="width: 50%;"></div>
          </div>
        </div>
      </div>
    </nav>

    <!-- 主要内容 -->
    <main class="container mx-auto px-4 py-8">
      <div class="max-w-3xl mx-auto space-y-6">
        <!-- 页面标题 -->
        <div class="text-center">
          <h1 class="text-2xl font-bold text-psychology-primary mb-2">基本信息</h1>
          <p class="text-gray-600">请提供一些基本信息，这将帮助我们提供更准确的结果分析</p>
        </div>

        <!-- 表单 -->
        <BasicInfoForm 
          :assessmentType="assessmentType"
          @submit="handleSubmit"
          @back="goBack"
        />

        <!-- 底部提示 -->
        <div class="text-center text-sm text-gray-500">
          第 1 步，共 3 步：基本信息收集
        </div>
      </div>
    </main>

    <!-- 回到顶部 -->
    <BackToTop />
  </div>
</template>

<script>
import BasicInfoForm from '../components/assessment/BasicInfoForm.vue'
import BackToTop from '../components/BackToTop.vue'
import { createSession } from '../utils/sessionStorage.js'

export default {
  name: 'BasicInfoPage',
  components: {
    BasicInfoForm,
    BackToTop
  },
  data() {
    return {
      assessmentType: 'self'
    }
  },
  created() {
    this.assessmentType = this.$route.query.type || 'self'
    console.log('BasicInfoPage created, assessmentType:', this.assessmentType)
  },
  methods: {
    goBack() {
      this.$router.go(-1)
    },
    handleSubmit(formData) {
      // 保存表单数据到localStorage（向后兼容）
      localStorage.setItem('rpi_basic_info', JSON.stringify(formData))
      
      // 创建新会话，包含基本信息
      const session = createSession({
        type: this.assessmentType,
        demographics: formData,
        responses: {}, // 空对象，表示还没有答题
        currentPage: 0
      })
      
      console.log('Created new session with demographics:', session.id)
      
      // 跳转到问卷页面，传递sessionId
      this.$router.push({
        path: '/assessment/questions',
        query: { 
          type: this.assessmentType,
          sessionId: session.id
        }
      })
    }
  }
}
</script>

